var React = require('react');

function SearchInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"style":{"fill":"none"},"cx":"35.22","cy":"35.27","r":"26.97","key":0}),React.createElement("line",{"style":{"fill":"none"},"x1":"53.94","y1":"54.68","x2":"82.85","y2":"83.58","key":1})]);
}

SearchInline.defaultProps = {"version":"1.1","baseProfile":"basic","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 91.1 91.88","xmlSpace":"preserve"};

module.exports = SearchInline;

SearchInline.default = SearchInline;
